// Efecto "inset" (onda que crece desde el punto de clic) para botones antd,
// calcado del mismo efecto usado en el módulo de Centro de Conciliación
// (src/components/forms/centro_conciliacion/FormCentroConciliacion.jsx) para
// que el resto de las pantallas de expediente compartan la misma animación.
const createWaveHolder = (node) => {
  const { borderWidth } = getComputedStyle(node);
  const borderWidthNum = Number.parseInt(borderWidth, 10) || 0;
  const div = document.createElement("div");
  div.style.position = "absolute";
  div.style.inset = `-${borderWidthNum}px`;
  div.style.borderRadius = "inherit";
  div.style.background = "transparent";
  div.style.zIndex = "999";
  div.style.pointerEvents = "none";
  div.style.overflow = "hidden";
  node.appendChild(div);
  return div;
};

const createWaveDot = (holder, color, left, top, size = 0) => {
  const dot = document.createElement("div");
  dot.style.position = "absolute";
  dot.style.insetInlineStart = `${left}px`;
  dot.style.top = `${top}px`;
  dot.style.width = `${size}px`;
  dot.style.height = `${size}px`;
  dot.style.borderRadius = "50%";
  dot.style.background = color;
  dot.style.transform = "translate3d(-50%, -50%, 0)";
  dot.style.transition = "all 1s ease-out";
  holder.appendChild(dot);
  return dot;
};

const runWave = (node, event, color) => {
  const holder = createWaveHolder(node);
  const rect = holder.getBoundingClientRect();
  const left = event.clientX - rect.left;
  const top = event.clientY - rect.top;
  const dot = createWaveDot(holder, color, left, top);
  requestAnimationFrame(() => {
    dot.ontransitionend = () => {
      holder.remove();
    };
    dot.style.width = "200px";
    dot.style.height = "200px";
    dot.style.opacity = "0";
  });
};

export const showInsetEffect = (node, { event, component }) => {
  if (component !== "Button") return;
  runWave(node, event, "rgba(10, 83, 154, 0.35)");
};

// Mismo efecto de onda, para botones nativos (<button>) que no pasan por
// el ConfigProvider de antd — así comparten la animación "happy work" con
// los botones Crear/Guardar del módulo de Centro de Conciliación.
export const triggerNativeWave = (event, color = "rgba(10, 83, 154, 0.35)") => {
  runWave(event.currentTarget, event, color);
};

// Efecto "happy work" (ráfaga de puntos que estalla desde el centro del
// botón), igual al usado por @ant-design/happy-work-theme en los botones
// Crear/Guardar, pero disparado a mano para botones nativos (<button>) del
// módulo de Tribunal que no pasan por ConfigProvider/HappyProvider de antd.
const HAPPY_DOT_COUNT = 8;

export const triggerHappyWave = (event, color = "#0A539A") => {
  const node = event.currentTarget;
  const rect = node.getBoundingClientRect();
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;
  const startRadius = Math.min(rect.width, rect.height) / 2;

  const holder = document.createElement("div");
  holder.style.position = "fixed";
  holder.style.left = "0px";
  holder.style.top = "0px";
  holder.style.zIndex = "9999";
  holder.style.pointerEvents = "none";
  document.body.appendChild(holder);

  const offsetAngle = Math.random() * 360;
  const dots = [];

  for (let i = 0; i < HAPPY_DOT_COUNT; i += 1) {
    const angle = offsetAngle + (360 / HAPPY_DOT_COUNT) * i;
    const rad = (angle * Math.PI) / 180;
    const startX = Math.cos(rad) * startRadius;
    const startY = Math.sin(rad) * startRadius;
    const endDist = startRadius + 16 + Math.random() * 14;
    const endX = Math.cos(rad) * endDist;
    const endY = Math.sin(rad) * endDist;
    const size = 4 + Math.random() * 4;

    const dot = document.createElement("div");
    dot.style.position = "fixed";
    dot.style.left = `${cx + startX}px`;
    dot.style.top = `${cy + startY}px`;
    dot.style.width = `${size}px`;
    dot.style.height = `${size}px`;
    dot.style.borderRadius = "50%";
    dot.style.transform = "translate3d(-50%, -50%, 0) scale(1)";
    dot.style.opacity = "1";
    dot.style.transition = "left .5s cubic-bezier(0.19,1,0.22,1), top .5s cubic-bezier(0.19,1,0.22,1), transform .5s cubic-bezier(0.19,1,0.22,1), opacity .5s cubic-bezier(0.19,1,0.22,1)";
    if (Math.random() > 0.4) {
      dot.style.background = color;
    } else {
      dot.style.border = `1px solid ${color}`;
    }
    holder.appendChild(dot);
    dots.push({ dot, endX, endY });
  }

  requestAnimationFrame(() => {
    dots.forEach(({ dot, endX, endY }, index) => {
      dot.style.left = `${cx + endX}px`;
      dot.style.top = `${cy + endY}px`;
      dot.style.opacity = "0";
      dot.style.transform = "translate3d(-50%, -50%, 0) scale(0.4)";
      if (index === dots.length - 1) {
        dot.ontransitionend = () => holder.remove();
      }
    });
  });
};
